import React, { useState, useEffect } from "react";
import NavBar from "./tools/navbar.js";
import { useSelector } from "react-redux";
import { useStyletron } from "baseui";
import WindowSticker from "./features/vehicles/windowSticker.js";
import Chatbot from "./tools/chatbot.js";

// MainLayout.js
export default function MainLayout({ children }) {
  const [locationLabel, setLocationLabel] = useState("");
  const [css] = useStyletron();
  const user = useSelector((state) => state.user);

  const retrieveLoginLocationId = async () => {
    const storedLocation = localStorage.getItem("location");
    if (storedLocation) {
      try {
        const parsedLocation = JSON.parse(storedLocation);
        if (parsedLocation[0] && parsedLocation[0].id) {
          setLocationLabel(parsedLocation[0].label);
        } else {
          console.warn("Location ID not found in stored location.");
        }
      } catch (error) {
        console.error("Error parsing location from localStorage:", error);
      }
    } else {
      console.warn("No location found in localStorage.");
    }
  };

  useEffect(() => {
    retrieveLoginLocationId();
  });

  // Function to toggle sidebar
  // const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div>
      <NavBar />
      <Chatbot user={user} />
      {user.location_id.length > 1 && (
        <p
          className={css({
            position: "absolute",
            color: "green",
            right: "3rem",
          })}
        >
          Current Location: {locationLabel}
        </p>
      )}
      {children}
    </div>
  );
}

// Higher-order component
// export function withMainLayout(Component) {
//   return function (props) {
//     return (
//       <MainLayout>
//         <Component {...props} />
//       </MainLayout>
//     );
//   };
// }

export function withMainLayout(Component) {
  return function (props) {
    // Check if the component is WindowSticker
    if (Component === WindowSticker) {
      // If it is, return just the component without the layout
      return <Component {...props} />;
    }

    // Otherwise, return the component wrapped in the layout
    return (
      <MainLayout>
        <Component {...props} />
      </MainLayout>
    );
  };
}
